var resources = require('items-view-strings');
    var strings = resources['_J1KVCrq3Mhcm5geZbLcTzA'];
export { strings };
export default strings;
